import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import '../../../scss/pages/Employee helpdesk/Resolved Request/resolvedRequest.scss';
import TagOpenReq from '../../../asset/svg/TagOpenReq.svg';
import Chat from '../../../asset/svg/Chat.svg';
import EllipseDot from '../../../asset/svg/EllipseDot.svg';
import Calendar from '../../../asset/svg/Calendar-Icon.svg'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { EMPLOYEE_HELPDESK_COMMENTS } from '../../../utils/Constants';
import { GET_TICKET_DATA } from '../../../sagas/type';
import moment from 'moment';

function ResolvedRequest() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { EmployeeTickets } = useSelector(mapStateToProps);

    const handleCheckComments = (ticketNo) => {
        navigate(EMPLOYEE_HELPDESK_COMMENTS, { state: { ticketNo: ticketNo } })
        dispatch({
            type: GET_TICKET_DATA,
            payload: ticketNo,
        })
    }

    return (
        <div className='Resolved-request-container'>
            <div className='Resolved-request-container_Card-Head'>
                {EmployeeTickets && EmployeeTickets?.length > 0 ? <>
                    {EmployeeTickets?.filter(item => item?.status === 'CLOSED')?.sort((a, b) => new Date(b.updatedDate) - new Date(a.updatedDate)).map((request) => {
                        return (
                            <Box key={request?.ticketNo} sx={{ marginTop: "10px" }} onClick={() => handleCheckComments(request?.ticketNo)}>
                                <Box className='Resolved-request-container_Card-Head_Data'>
                                    <div className='Resolved-request-container_Card-Head_Data_Child'>
                                        <div className='Resolved-request-container_Card-Head_Data_Child_Child-sub'>
                                            <div className='Resolved-request-container_Card-Head_Data_Child_Child-sub_Tag-status'>
                                                <div className='Resolved-request-container_Card-Head_Data_Child_Child-sub_Tag-status_Icon-tag'>
                                                    <img src={TagOpenReq} width='20px' height='20px' />
                                                    <Typography sx={{ fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif", color: "rgba(255, 255, 255, 0.40)" }}>{request.ticketNo}</Typography>
                                                </div>
                                                {request.status == 'CLOSED' && <div className='Resolved-request-container_Card-Head_Data_Child_Child-sub_Tag-status_Resolved-sts'>
                                                    <Typography sx={{ color: "#6FDF97", fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif" }}>Resolved</Typography>
                                                </div>}
                                            </div>
                                            {request?.replies?.length > 0 && <div className='Resolved-request-container_Card-Head_Data_Child_Child-sub_Reply'>
                                                <img src={Chat} width='15px' height='15px' />
                                                <Typography sx={{ color: "#FFF", fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{`${request?.replies?.length + " " + "Reply"}`}</Typography>
                                            </div>}
                                        </div>
                                        <div className='Resolved-request-container_Card-Head_Data_Child_Child-sub2'>
                                            <div className='Resolved-request-container_Card-Head_Data_Child_Child-sub2_Category'>
                                                <Typography sx={{ color: "#FFF", fontSize: "14px", fontWeight: 600, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{request?.subCategoryVo?.name}</Typography>
                                                <img src={EllipseDot} width='7px' height='7px' />
                                                <Typography sx={{ color: "rgba(255, 255, 255, 0.40)", fontSize: "12px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{request?.subCategoryVo?.category}</Typography>
                                            </div>
                                            <Typography sx={{ color: "rgba(255, 255, 255, 0.70)", fontSize: "12px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{request?.description}</Typography>
                                            <div className='Resolved-request-container_Card-Head_Data_Child_Child-sub2_Date-Icon'>
                                                <img src={Calendar} width='10px' height='10px' />
                                                <Typography sx={{ color: "#FFF", fontSize: "10px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap", opacity: 0.4 }}>{moment(request?.createdDate).format("DD MMM YYYY, HH:mm")}</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </Box>
                            </Box>
                        )
                    })}
                </> : <div className='Open-request-container_No-open-requests'>
                    <div className='Open-request-container_No-open-requests_Content'>
                        <div className='Open-request-container_No-open-requests_Content_Text'>
                            <Typography className='Open-request-container_No-open-requests_Content_Text_Text-content'>No Resolved Requests</Typography>
                        </div>
                        {/* <div className='Open-request-container_No-open-requests_Content_Button'>
                            <button className='Open-request-container_No-open-requests_Content_Button_active-button' onClick={handleRaiseRequest}>Raise a Request</button>
                        </div> */}
                    </div>
                </div>
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        EmployeeTickets: state?.employeeHelpdesk?.GetEmployeeTickets,
    }
}

export default ResolvedRequest